import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';

import * as ErrorTypes from '../../constants/ErrorTypes';
import NotAvailableAppkey from './NotAvailableAppkey';
import NotConsultable from './NotConsultable';
import NotFound from './NotFound';
import NotTalkUser from './NotTalkUser';
import Unknown from './Unknown';
import NotVerifiedAgeAuth from "./NotVerifiedAgeAuth";

export default class ErrorContent extends Component {

  static propTypes = {
    error: PropTypes.instanceOf(Immutable.Map).isRequired,
    device: PropTypes.instanceOf(Immutable.Map),
    profile: PropTypes.object
  }

  render() {
    const { error } = this.props;
    const type = error.get('type');
    switch (type) {
      case ErrorTypes.notConsultable: return <NotConsultable {...this.props} />;
      case ErrorTypes.talkUserNotMapped: return <NotTalkUser {...this.props} />;
      case ErrorTypes.notAvailableAppkey: return <NotAvailableAppkey {...this.props} />;
      case ErrorTypes.notVerifiedAgeAuth: return <NotVerifiedAgeAuth {...this.props} />;
      case ErrorTypes.notFound: return <NotFound {...this.props} />;
      default: return <Unknown {...this.props} />;
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/ErrorContent/index.js